import React from 'react'
import { usePutRequest } from '../hooks/request'
import ServerError from './componentsFinance/common/ServerError'
import ResultForm from './ResultForm'
import { RESULT_DETAIL } from '../urls'

export default function ResultUpdate({ onCancel, onUpdate, report }) {
    const url = RESULT_DETAIL.replace('{id}', report.id)
    const rotationUpdate = usePutRequest({ url })

    async function onSubmit(data, actions) {
        const { success } = await rotationUpdate.request({ data })

        if (success) {
            actions.resetForm()
            onUpdate()
        }
    }

    return (
        <div>
            <b>Изменить данные о враче</b><br /><br />
            <ServerError error={rotationUpdate.error} />
            <ResultForm
                initialValues={report}
                onSubmit={onSubmit}
                onCancel={onCancel}
                loading={rotationUpdate.loading} />
        </div>
    )
}
